import React, { useEffect } from "react";
import { attributionApi, readAdParams } from "@shared/api/attribution.api";
import { Seo } from "@shared/components/Seo";
import { CONTACTS } from "@shared/config/seo-schemas";
import { getMetrikaClientId } from "@shared/helper_lib/metrika";
import { LoadingDots } from "@shared/ui/LoadingDots";

/**
 * Прокладка между Директом и ботом. Прямая ссылка на t.me теряет yclid —
 * Яндекс дописывает его только к URL сайта. Поэтому объявления ведут сюда:
 * страница сохраняет метки, получает короткий код и уводит в бота с ним.
 */
export const TgRedirectPage: React.FC = () => {
  useEffect(() => {
    const redirect = async (): Promise<void> => {
      let startPayload = "yadirect";

      try {
        const adParams = readAdParams(window.location.search);
        const ymClientId = await getMetrikaClientId();

        startPayload = await attributionApi.createClick({
          ...adParams,
          ymClientId,
          landingUrl: window.location.href
        });
      } catch (error) {
        console.warn("Не удалось сохранить рекламный клик, уходим с грубой меткой:", error);
      } finally {
        // Редирект обязан произойти при любом исходе: это трафик прямо из объявления
        window.location.replace(`${CONTACTS.transcribeBotUrl}?start=${startPayload}`);
      }
    };

    void redirect();
  }, []);

  return (
    <>
      <Seo
        title="Переход в Telegram-бот | Polotno"
        description="Открываем Telegram-бот Polotno для расшифровки аудио и видео в текст."
        path="/tg"
        noindex
      />
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
        <LoadingDots />
        <p className="text-muted-foreground">Открываем Telegram-бот...</p>
      </div>
    </>
  );
};
